// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-form-item__label:after{content:\":\"}.el-form-item__label{width:85px;font-weight:700}.amo-info{cursor:pointer}.card-new{height:100%;display:flex;justify-content:center}.align-center,.card-new{align-items:center}", ""]);
// Exports
module.exports = exports;
